import { createSelector } from 'reselect';

export const selectRoot = (state) => state.audioPlayer || {};

export const selectCurrentAudioSrc = createSelector(
	selectRoot,
	(data) => data.currentAudioSrc || ''
);
